import { render, staticRenderFns } from "./card-faq-kynorelle.vue?vue&type=template&id=72e3c679&scoped=true&"
import script from "./card-faq-kynorelle.vue?vue&type=script&lang=js&"
export * from "./card-faq-kynorelle.vue?vue&type=script&lang=js&"
import style0 from "./card-faq-kynorelle.vue?vue&type=style&index=0&id=72e3c679&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e3c679",
  null
  
)

export default component.exports